var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconKakao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37.372,
    height: 37.372,
    rx: 18.686,
    fill: "#F2C94C",
    stroke: "#F2C94C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.035 18.75a7.307 7.307 0 0 1-.785 3.314 7.413 7.413 0 0 1-6.628 4.099 7.31 7.31 0 0 1-3.314-.785l-4.971 1.657 1.657-4.971a7.307 7.307 0 0 1-.785-3.314 7.413 7.413 0 0 1 4.099-6.628 7.308 7.308 0 0 1 3.314-.785h.436a7.395 7.395 0 0 1 6.977 6.977v.436Z",
    fill: "#422525"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKakao);
export default __webpack_public_path__ + "static/media/icon-kakao.478f559ec946d3e6287fd4608fcd3d8a.svg";
export { ForwardRef as ReactComponent };